import {
  HHLink,
  HHStack,
  HHTypography,
} from '@hinge-health/react-component-library';
import { GridValueGetterParams } from '@mui/x-data-grid';
import { routes } from '../../../constants/strings/routes';
import { ClientType } from '../../../types';
import { ReleasableHoldReasons } from './bill-management-types';

// ACCOUNTS-AND-PLAN-MIGRATION: clientId here is the hold change-to target identity, not resolvable via contract_id — will be addressed by the Accounts & Plan migration.
export interface ClientCellProps {
  clients?: ClientType[];
  holdType?: string;
  clientId?: string;
  // This is the id of the client in the grid as that's the value of the clientId in for this row.
  id: GridValueGetterParams['id'];
  name?: string;
  loading?: boolean;
}
export const ClientCell = ({
  clients,
  holdType,
  clientId,
  id,
  name,
  loading,
}: ClientCellProps): JSX.Element => {
  if ((!id && !name) || loading) {
    return <HHTypography hhVariant="caption">Loading...</HHTypography>;
  }

  return (
    <HHStack>
      {clients &&
      id &&
      clientId &&
      !loading &&
      clients?.length >= 1 &&
      holdType === ReleasableHoldReasons.CLIENT_CHANGE ? (
        <HHStack>
          <HHLink
            href={`${routes.billing.home}/${routes.billing.clientPath}/${id}`}
            target="_blank"
            sx={{ textDecoration: 'line-through', color: 'gray' }}
          >
            {name}
          </HHLink>
          <HHLink
            color="primary"
            href={`${routes.billing.home}/${routes.billing.clientPath}/${clientId}`}
            target="_blank"
            sx={{ textDecoration: 'none' }}
          >
            {clients.filter(client => client.id === parseInt(clientId))[0].name}
          </HHLink>
        </HHStack>
      ) : (
        <HHLink
          color="primary"
          href={`${routes.billing.home}/${routes.billing.clientPath}/${id}`}
          target="_blank"
          sx={{ textDecoration: 'none' }}
        >
          {name}
        </HHLink>
      )}
    </HHStack>
  );
};
